module.exports = __webpack_public_path__ + "static/media/location-pin.4d4f39d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/location-pin.svg
// module id = 887
// module chunks = 0